import { get, post } from  "@/utils/request";
// 分页获取公告
export const getDogsAfficheListPage = data => post('affice/getDogsAfficheListPage', data);
// 添加公告
export const saveDogsAffiche = data => post('affice/saveDogsAffiche', data);
//发送当前公告给所有人
export const sendMerchantAfficheAll = data => post('affice/sendMerchantAfficheAll', data);
//修改公告
export const updateDogsAffiche = data => post('/affice/updateDogsAffiche', data);




// WEBPACK FOOTER //
// ./src/api/notice.js